import loadable from '@loadable/component';

export const CmsAmpPageOrPostBodyLoadable = loadable(
  () => import('./CmsAmpPageOrPostBody'),
  { resolveComponent: (module) => module.CmsAmpPageOrPostBody },
);
